import React from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';
import { LoadingSpinner } from './LoadingSpinner';

export enum LoadingSpinnerModifier {
  OVERLAY = 'overlay',
}

type LoadingSpinnerContainerProps = {
  modifier?: Modifier<LoadingSpinnerModifier>;
};

export function LoadingSpinnerContainer({ modifier }: LoadingSpinnerContainerProps) {
  return (
    <div className={bem('loading-spinner__outer-container', modifier)}>
      <div className="loading-spinner__inner-container">
        <LoadingSpinner />
      </div>
    </div>
  );
}
